import { render } from "./doubleTankLayout.vue?vue&type=template&id=9fc2d95c"
import script from "./doubleTankLayout.vue?vue&type=script&lang=js"
export * from "./doubleTankLayout.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/display-measurement-prd-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__